var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.logDialogVisible,
            title: "操作日志",
            width: "60%",
            "modal-append-to-body": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.logDialogVisible = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c(
            "el-table",
            { attrs: { height: "500", data: _vm.list, border: "" } },
            [
              _c("el-table-column", {
                attrs: { prop: "time", label: "操作时间" },
              }),
              _c("el-table-column", {
                attrs: { prop: "operator", label: "操作人" },
              }),
              _c("el-table-column", {
                attrs: { prop: "type", label: "操作类型" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.type === 1
                          ? _c("span", [_vm._v("新增")])
                          : _vm._e(),
                        scope.row.type === 2
                          ? _c("span", [_vm._v("修改")])
                          : _vm._e(),
                        scope.row.type === 3
                          ? _c("span", [_vm._v("删除")])
                          : _vm._e(),
                        scope.row.type === 4
                          ? _c("span", [_vm._v("上线")])
                          : _vm._e(),
                        scope.row.type === 5
                          ? _c("span", [_vm._v("下线")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "修改内容" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.getDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n            查看\n          ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("ElementPagination", {
            attrs: {
              "current-page": _vm.searchParams.current,
              "page-size": _vm.searchParams.size,
              total: _vm.searchParams.total,
              "page-sizes": [10, 20, 30, 40, 50],
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
          _c("ModificationDiff", { ref: "diffDialog" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }